export const fetchPressReleasesData = async () => {
  try {
      const headers = new Headers({
          "cache-control": "max-age=172800"
      })
    const response = await fetch('./content/about/page-components/article/press-releases.json', {
        headers: headers
    });
    const pressReleases = await response.json();
    return pressReleases;
  } catch (e) {
    console.log(e)
  }
};



// WEBPACK FOOTER //
// ./src/api/fetchPressReleasesData.js